module.exports = __webpack_public_path__ + "img/power-swiper-item (6).7c052cb3.png";